import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { createRoot } from 'react-dom/client';
import { initReactI18next } from 'react-i18next';
// import { pdfjs } from 'react-pdf';
import '@fontsource/inter';
import {
  extendTheme as extendJoyTheme,
  CssVarsProvider as JoyCssVarsProvider,
} from '@mui/joy/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {
  THEME_ID as MATERIAL_THEME_ID,
  CssVarsProvider as MaterialCssVarsProvider,
  extendTheme as materialExtendTheme,
} from '@mui/material/styles';
import { QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import './index.css';
import store from './redux/store';
import { AppRouter } from './router';
import { installTranslateCrashGuard } from './utils/translateCrashGuard';
import queryClient from './services/queryClient';

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'nl'],
    fallbackLng: 'en',
    debug: false,
    // Options for language detector
    detection: {
      order: ['cookie', 'htmlTag', 'path'],
      caches: ['cookie'],
    },
    // react: { useSuspense: false },
    backend: {
      loadPath: '/assets/locales/{{lng}}/translation.json',
    },
  });

const materialTheme = materialExtendTheme({});
const joyTheme = extendJoyTheme({
  fontFamily: {
    body: 'Century Gothic, sans-serif',
    display: 'Century Gothic, sans-serif',
    code: 'Century Gothic, sans-serif',
  },
  colorSchemes: {
    light: {
      palette: {
        // background: {
        //   backdrop: '#FBFBF3',
        //   surface: '#F8F8ED',
        //   body: '#F5F5E6',
        //   level1: '#F2F2DE',
        //   level2: '#EFEFD7',
        //   level3: '#ECECD0',
        //   popup: '#E9E9C8',
        //   tooltip: '#E6E6C1',
        // },
        primary: {
          '50': '#f5f3ff',
          '100': '#ede9fe',
          '200': '#ddd6fe',
          '300': '#c4b5fd',
          '400': '#a78bfa',
          '500': '#662C82',
          '600': '#7c3aed',
          '700': '#662C82',
          '800': '#5b21b6',
          '900': '#4c1d95',
        },
      },
    },
  },
});

// Must run before the first render: browser page-translation rewrites text
// nodes under React and the resulting removeChild throws blank the whole app.
// See utils/translateCrashGuard for the full reasoning and its trade-off.
installTranslateCrashGuard();

const root = createRoot(document.getElementById('root') as any);

root.render(
  <MaterialCssVarsProvider theme={{ [MATERIAL_THEME_ID]: materialTheme }}>
    <JoyCssVarsProvider theme={joyTheme}>
      <CssBaseline enableColorScheme />
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <AppRouter />
        </QueryClientProvider>
      </Provider>
    </JoyCssVarsProvider>
  </MaterialCssVarsProvider>
);
